import {HttpErrorResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {SnackbarService} from '../services/snackbar.service';

export type ErrorHandlerFunction = (error: HttpErrorResponse, services: { snackbar: SnackbarService }) => Observable<never>;

export const specialRoutesErrorMap: { [url: string]: ErrorHandlerFunction } = {
  '/api/v1/servicos/eventos/': (error, { snackbar }) => {
    return throwError(() => error);
  },
};
